// Copyright (c) 2019 Deere & Company

import './smart-form-attachment-link.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleDownloadClick() {

    this.actions.setRgaResultsNavigation({
        currentPage: this.currentPage,
        lastOpenedRgaNumber: this.rgaNumber,
        shouldRestore: true
    });

    this.actions.getRgaDetails(this.objectId, false);
    this.actions.getRgaFiles(this.objectId);

}

function getIconClassName(icon) {

    const map = {
        PDF: 'button-icon-pdf'
    };

    return map[icon];

}

const SmartFormAttachmentLink = props => {

    const formattedDisplayText = props.translate ? <FormattedMessage id={props.displayText}/> : props.displayText;

    return (
        <button
            className={props.showAsButton ? 'smart-form-button' : 'button-text smart-form-link'}
            onClick={handleDownloadClick.bind(props)}
        >
            {props.showAsButton && props.showButtonIcon &&
                <span className={getIconClassName(props.icon)}/>
            }
            {formattedDisplayText}
        </button>
    );

};

SmartFormAttachmentLink.displayName = 'SmartFormAttachmentLink';
SmartFormAttachmentLink.propTypes = {
    actions: PropTypes.object.isRequired,
    currentPage: PropTypes.number.isRequired,
    displayText: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    objectId: PropTypes.object.isRequired,
    rgaNumber: PropTypes.string.isRequired,
    showAsButton: PropTypes.bool.isRequired,
    showButtonIcon: PropTypes.bool.isRequired,
    translate: PropTypes.bool.isRequired
};
SmartFormAttachmentLink.defaultProps = {
    icon: 'NONE',
    showAsButton: false,
    showButtonIcon: false,
    translate: false
};
export default SmartFormAttachmentLink;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/components/smart-form-attachment-link/smart-form-attchment-link.js